<template>
  <div class="cms-section-item">
    <ul class="u-reset cms-section-item__item-list">
      <li
        v-for="(componentItem, componentItemIdx) in componentItemList"
        :key="componentItemIdx"
        class="cms-section-item__item"
      >
        <component :is="$options.transformType(componentItem.type)" v-bind="componentItem" />
      </li>
    </ul>
  </div>
</template>

<script>
  import CmsImageList from '@/components/cms/cms-image-list/cms-image-list'
  import CmsPdfLink from '@/components/cms/cms-pdf-link/cms-pdf-link'
  import CmsPdfLinkList from '@/components/cms/cms-pdf-link-list/cms-pdf-link-list'
  import CmsRichText from '@/components/cms/cms-rich-text/cms-rich-text'
  import { transformType } from '@/assets/js/util/misc/transform'

  export default {
    components: { CmsImageList, CmsPdfLink, CmsPdfLinkList, CmsRichText },
    props: {
      componentItemList: {
        type: Array,
        required: true,
      },
    },
    transformType,
  }
</script>

<style lang="scss" src="./_cms-section-item.scss" />
